import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Widgetsbar from './Widgetsbar';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

interface WidgetsbarWrapperProps {
  userTimezone: string;
}

export default function WidgetsbarWrapper({ userTimezone }: WidgetsbarWrapperProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <Widgetsbar userTimezone={userTimezone} />
    </QueryClientProvider>
  );
}
